export const isItemExpired = (item) => {
  if (!item.draw_date) return false;
  return Date.now() >= item.draw_date * 1000;
};

export const markExpiredCartItems = (items) => {
  const now = Date.now();
  return items.map((item) => ({
    ...item,
    isExpired: item.draw_date * 1000 <= now,
  }));
};

export const hasExpiredItems = (items) => items.some((item) => isItemExpired(item));
